import React from "react";
import { Table, TableHead, TableRow, TableCell, TableBody, Paper, TableContainer, IconButton, Avatar, Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PrintIcon from "@mui/icons-material/Print";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { getMediaUrl } from "../../../../utils/mediaUrl";

interface Props {
  rows: any[];
  onEdit: (row: any) => void;
  onDelete: (row: any) => void;
  onExport: () => void;
  onPrint: (row: any) => void;
  onPreview: (row: any) => void;
}

const StudentIdCardTable: React.FC<Props> = ({ rows, onEdit, onDelete, onExport, onPrint, onPreview }) => {
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Photo</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Scholar No</TableCell>
            <TableCell>Class</TableCell>
            <TableCell>Section</TableCell>
            <TableCell>DOB</TableCell>
            <TableCell>Blood Group</TableCell>
            <TableCell>Valid Upto</TableCell>
            <TableCell>Data Source</TableCell>
            <TableCell align="right">
              <Button size="small" variant="outlined" onClick={onExport}>
                Export
              </Button>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((r) => (
            <TableRow key={r.id}>
              <TableCell>
                <Avatar src={getMediaUrl(r.photoUrl)} />
              </TableCell>
              <TableCell>{r.studentName}</TableCell>
              <TableCell>{r.scholarNo}</TableCell>
              <TableCell>{r.className}</TableCell>
              <TableCell>{r.sectionName}</TableCell>
              <TableCell>{r.dob ? new Date(r.dob).toLocaleDateString() : "-"}</TableCell>
              <TableCell>{r.bloodGroup || "-"}</TableCell>
              <TableCell>{r.validUpto ? new Date(r.validUpto).toLocaleDateString() : "-"}</TableCell>
              <TableCell>{r.dataSource}</TableCell>
              <TableCell align="right">
                <IconButton size="small" onClick={() => onPreview(r)} title="Preview HTML">
                  <VisibilityIcon />
                </IconButton>
                <IconButton size="small" onClick={() => onEdit(r)}>
                  <EditIcon />
                </IconButton>
                <IconButton size="small" onClick={() => onDelete(r)}>
                  <DeleteIcon />
                </IconButton>
                <IconButton size="small" onClick={() => onPrint(r)}>
                  <PrintIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
          {rows.length === 0 && (
            <TableRow>
              <TableCell colSpan={10} align="center">
                No ID cards
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default StudentIdCardTable;
